const swipers = [];

const initSlider = (container) => new window.Swiper(container, {
  slidesPerView: 1,
  speed: 800,
  effect: 'fade',

  pagination: {
    el: container.querySelector('[data-slider-pagination]'),
    type: 'fraction',
  },

  navigation: {
    nextEl: container.querySelector('[data-slider-next]'),
    prevEl: container.querySelector('[data-slider-prev]'),
  },
});

const initSetupSwiper = (container) => {
  swipers.push(initSlider(container));
};

const initSliders = () => {
  const sliderContainers = document.querySelectorAll('[data-slider]');

  if (!sliderContainers.length) {
    return;
  }

  sliderContainers.forEach((it) => {
    initSetupSwiper(it);
  });
};

export {initSliders, swipers};
